module.exports = __webpack_public_path__ + "static/media/wa.feb0a686.svg";